import React, { useMemo, useState } from 'react';
import { Icon } from '../Icon';

const displayName = (ch) => (ch.name.startsWith('_private_') ? (ch.description || ch.name) : ch.name);
const iconNameOf = (ch) => (ch.is_announcement ? 'megaphone' : ch.name.startsWith('_private_') ? 'user' : ch.is_private ? 'lock' : 'hash');
const iconLabel = { megaphone: '공지 채널', user: '개인 대화', lock: '비공개 채널', hash: '채널' };

// 채널 종류 아이콘: 일반 # · 비공개 자물쇠 · 공지 확성기 · 개인 대화 사람
export const ChannelIcon = ({ channel, size = 16, className }) => {
    const name = iconNameOf(channel);
    return <Icon name={name} size={size} className={className} aria-label={iconLabel[name]} role="img" aria-hidden={undefined} />;
};

// 채널 목록 (PC: 왼쪽 패널, 모바일: 왼쪽에서 열리는 서랍)
// asScreen: 휴대폰에서 서랍이 아니라 한 화면 전체를 쓰는 채팅 목록
export function ChannelSidebar({ channels, categoryOrder = [], currentChannelId, onSelect, isAdmin, isOpen, onClose, unread = {}, width, notifyLevels = {}, asScreen = false }) {
    const [filter, setFilter] = useState('');

    const groups = useMemo(() => {
        const q = filter.trim().toLowerCase();
        const byCat = {};
        channels
            .filter(ch => !q || displayName(ch).toLowerCase().includes(q))
            .forEach(ch => { (byCat[ch.category || ''] ||= []).push(ch); });
        const order = categoryOrder.filter(c => byCat[c]);
        Object.keys(byCat).forEach(c => { if (c && !order.includes(c)) order.push(c); });
        return ['', ...order].filter(c => byCat[c]).map(name => ({ name, channels: byCat[name] }));
    }, [channels, categoryOrder, filter]);

    return (
        <>
            {isOpen && !asScreen && <div className="drawer-backdrop only-mobile" onClick={onClose} />}
            <aside className={`channel-panel${isOpen ? ' open' : ''}${asScreen ? ' as-screen' : ''}`} style={width && !asScreen ? { '--panel-width': `${width}px` } : undefined}>
                <div className="panel-head">
                    <span>{asScreen ? '채팅' : '채널'}</span>
                    {!asScreen && <button className="nav-icon-btn only-mobile" onClick={onClose} aria-label="닫기"><Icon name="x" /></button>}
                </div>
                <div className="channel-filter">
                    <input type="search" placeholder="채널 검색" value={filter} onChange={e => setFilter(e.target.value)} />
                </div>
                <ul className="channel-list">
                    {!channels.length && <li className="panel-empty">{isAdmin ? '관리자 페이지에서 채널을 만들어 주세요.' : '아직 채널이 없습니다.'}</li>}
                    {!!channels.length && !groups.length && <li className="panel-empty">검색 결과 없음</li>}
                    {groups.map(group => (
                        <React.Fragment key={group.name || '__none'}>
                            {group.name && <li className="channel-category">{group.name}</li>}
                            {group.channels.map(ch => {
                                const u = unread[ch.id];
                                const count = u?.count || 0;
                                const muted = notifyLevels[ch.id] === 'none';
                                return (
                                    <li key={ch.id}>
                                        <button type="button"
                                        className={`channel-item${ch.id === currentChannelId ? ' active' : ''}${count && !muted ? ' has-unread' : ''}${muted ? ' muted' : ''}`}
                                        aria-current={ch.id === currentChannelId ? 'page' : undefined}
                                        onClick={() => { onSelect(ch.id); onClose(); }}
                                        title={ch.description || displayName(ch)}>
                                        <span className="channel-icon"><ChannelIcon channel={ch} /></span>
                                        <span className="channel-name">{displayName(ch)}</span>
                                        {muted && <span className="channel-muted" title="알림 꺼짐"><Icon name="bellOff" size={14} /></span>}
                                        {count > 0 && (!muted || u.hasMention) && <span className={`channel-badge${u.hasMention ? ' mention' : ''}`}>{count > 99 ? '99+' : count}</span>}
                                        </button>
                                    </li>
                                );
                            })}
                        </React.Fragment>
                    ))}
                </ul>
            </aside>
        </>
    );
}
